var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 8H10C8.4087 8 6.88258 8.63214 5.75736 9.75736C4.63214 10.8826 4 12.4087 4 14V34C4 35.5913 4.63214 37.1174 5.75736 38.2426C6.88258 39.3679 8.4087 40 10 40H38C39.5913 40 41.1174 39.3679 42.2426 38.2426C43.3679 37.1174 44 35.5913 44 34V14C44 12.4087 43.3679 10.8826 42.2426 9.75736C41.1174 8.63214 39.5913 8 38 8V8ZM38 12L25 20.94C24.696 21.1155 24.3511 21.2079 24 21.2079C23.6489 21.2079 23.304 21.1155 23 20.94L10 12H38Z",
    fill: "#2D1E2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsEmail);
export default __webpack_public_path__ + "static/media/contactUsEmail.d56eabf728e45ab6a1edfcbccb7e6627.svg";
export { ForwardRef as ReactComponent };